import { validateNickname } from '../models/nickname';

const LAST_NICKNAME_KEY = 'retro-space:last-nickname';

type LeaderboardStorageBackend = Pick<Storage, 'getItem' | 'setItem'>;

export class LeaderboardStorage {
  public constructor(private readonly storage?: LeaderboardStorageBackend) {}

  public readLastNickname(): string {
    try {
      const nickname = this.storage?.getItem(LAST_NICKNAME_KEY) ?? '';
      const validation = validateNickname(nickname);
      return validation.valid ? validation.nickname : '';
    } catch {
      return '';
    }
  }

  public recordSuccessfulNickname(nickname: string): void {
    const validation = validateNickname(nickname);
    if (!validation.valid) return;
    try {
      this.storage?.setItem(LAST_NICKNAME_KEY, validation.nickname);
    } catch {
      // Submission already succeeded; unavailable storage must not turn it into a failure.
    }
  }
}
